export const DropdownMobileData = [
  {
    id: '1',
    value: 'Cashier',
  },
  {
    id: '2',
    value: 'Admin',
  },
  {
    id: '3',
    value: 'Other',
  },
]

export const DropdownData = [
  {
    id: '1',
    value: 'Operations',
  },
  {
    id: '2',
    value: 'Finance',
  },
  {
    id: '3',
    value: 'Human Resource',
  },
  {
    id: '4',
    value: 'IT',
  },
  {
    id: '5',
    value: 'Support',
  },
  {
    id: '6',
    value: 'Marketing',
  },
  {
    id: '6',
    value: 'Others',
  },
]
